import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src2604562234/src/src/layouts/default.vue").then(m => m.default || m)),
  "with-global-nav": defineAsyncComponent(() => import("/codebuild/output/src2604562234/src/src/layouts/withGlobalNav.vue").then(m => m.default || m))
}